export { default as createTagWrapper } from './create-tag-wrapper';
